import Budget from '@/components/game/scenes/Budget';
import StatusMeters from '@/components/game/sidebar/StatusMeters';
import store from "@/store";

export default [
	{
		path: 'budget',
		name: "BUDGET",
		components: {
			gameSpace: Budget,
			sidebar: StatusMeters,
		},
	},
	{
		path: 'budget/complete',
		async beforeEnter(to, from, next) {
			const path = store.getters["game/chapters/active/serveCurveball"] ? "/game/curveball/serve" : "/game/magic-shop";
			next({ path });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/budgets.routes.js